export const ADMIN = 'ROLE_ADMIN';
export const INSTRUCTOR = 'ROLE_INSTRUCTOR';
export const INSTRUCTOR_VIEW_ONLY = 'ROLE_INSTRUCTOR_VIEW_ONLY';
export const STUDENT = 'ROLE_STUDENT';


/** WEBPACK FOOTER **
 ** ./src/constants/roles.js
 **/